var React = require('react');

function Export (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .export-svg {\n        fill: #bebebe;\n      }\n    ")),React.createElement("path",{"id":"Rounded_Rectangle_614","data-name":"Rounded Rectangle 614","className":"export-svg","d":"M1804,1620.01v-3.99a1,1,0,0,1,2,0v3.99A1,1,0,1,1,1804,1620.01Zm-3.02-5h3.97a0.99,0.99,0,1,1,0,1.98h-3.97A0.99,0.99,0,0,1,1800.98,1615.01Zm3.69,1.29a1.086,1.086,0,0,1,0,1.53l-3.84,3.84a1.085,1.085,0,0,1-1.53-1.54l3.83-3.83A1.08,1.08,0,0,1,1804.67,1616.3Z","transform":"translate(-1799 -1615)","key":1})]);
}

Export.defaultProps = {"width":"7","height":"7","viewBox":"0 0 7 7"};

module.exports = Export;

Export.default = Export;
